module.exports = __webpack_public_path__ + "img/icon_consult.ed088bc0.png";